(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-image-board"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-image-board')) {
    class InteractiveImageBoard extends HTMLElement {
      constructor() {
        super();
        this.images = [];
        this.activeImage = null;
        this.offset = { x: 0, y: 0 };
        this.isMobile = window.innerWidth <= 749;
        this.maxZIndex = 7;
        this.onDragStart = this.handleDragStart.bind(this);
        this.onDragMove = this.handleDragMove.bind(this);
        this.onDragEnd = this.handleDragEnd.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
      }

      connectedCallback() {
        this.setupImages();
        this.waitForImagesToLoad();
        if (!this.hasAttribute('data-fixed')) this.attachEventListeners();
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        this.images.forEach((image) => {
          image.removeEventListener('mousedown', this.onDragStart);
          image.removeEventListener('touchstart', this.onDragStart);
          image.removeEventListener('keydown', this.onKeyDown);
        });
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('touchmove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('resize', this.onResize);
      }

      setupImages() {
        this.images = Array.from(this.querySelectorAll('.ai-image-board__image'));
        this.updateMaxZIndex();
      }

      updateMaxZIndex() {
        let max = 0;
        this.images.forEach((image) => {
          const zIndex = parseInt(image.style.zIndex, 10) || parseInt(image.dataset.layer, 10) || 0;
          if (zIndex > max) max = zIndex;
        });
        this.maxZIndex = Math.max(max, 7);
      }

      waitForImagesToLoad() {
        const imageElements = this.querySelectorAll('img');
        const promises = Array.from(imageElements).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        });

        Promise.all(promises).then(() => this.positionImages());

        if (imageElements.length === 0) this.positionImages();
      }

      getImageSettings(image) {
        if (this.isMobile) {
          return {
            width: parseFloat(image.dataset.widthMobile),
            x: parseFloat(image.dataset.xMobile),
            y: parseFloat(image.dataset.yMobile),
            rotation: parseFloat(image.dataset.rotationMobile),
          };
        }

        return {
          width: parseFloat(image.dataset.widthDesktop),
          x: parseFloat(image.dataset.xDesktop),
          y: parseFloat(image.dataset.yDesktop),
          rotation: parseFloat(image.dataset.rotationDesktop),
        };
      }

      positionImages() {
        const boardRect = this.getBoundingClientRect();

        this.images.forEach((image) => {
          const settings = this.getImageSettings(image);
          const width = (boardRect.width * settings.width) / 100;

          image.style.width = width + 'px';
          image.style.height = 'auto';
          image.style.left = settings.x + '%';
          image.style.top = settings.y + '%';
          image.style.transform = 'translate(-50%, -50%) rotate(' + settings.rotation + 'deg)';
        });
      }

      attachEventListeners() {
        this.images.forEach((image) => {
          image.addEventListener('mousedown', this.onDragStart);
          image.addEventListener('touchstart', this.onDragStart, { passive: false });
          image.addEventListener('keydown', this.onKeyDown);
        });

        document.addEventListener('mousemove', this.onDragMove);
        document.addEventListener('touchmove', this.onDragMove, { passive: false });
        document.addEventListener('mouseup', this.onDragEnd);
        document.addEventListener('touchend', this.onDragEnd);
      }

      handleDragStart(e) {
        e.preventDefault();

        this.activeImage = e.currentTarget;
        this.bringToFront(this.activeImage);
        this.activeImage.classList.add('is-dragging');
        this.activeImage.focus({ preventScroll: true });

        const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
        const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
        const rect = this.activeImage.getBoundingClientRect();

        this.offset.x = clientX - rect.left - rect.width / 2;
        this.offset.y = clientY - rect.top - rect.height / 2;
      }

      handleDragMove(e) {
        if (!this.activeImage) return;

        e.preventDefault();

        const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
        const boardRect = this.getBoundingClientRect();
        const imageRect = this.activeImage.getBoundingClientRect();

        let newX = clientX - boardRect.left - this.offset.x;
        let newY = clientY - boardRect.top - this.offset.y;

        newX = Math.max(imageRect.width / 2, Math.min(boardRect.width - imageRect.width / 2, newX));
        newY = Math.max(imageRect.height / 2, Math.min(boardRect.height - imageRect.height / 2, newY));

        const settings = this.getImageSettings(this.activeImage);

        this.activeImage.style.left = (newX / boardRect.width) * 100 + '%';
        this.activeImage.style.top = (newY / boardRect.height) * 100 + '%';
        this.activeImage.style.transform = 'translate(-50%, -50%) rotate(' + settings.rotation + 'deg)';
      }

      handleDragEnd() {
        if (!this.activeImage) return;
        this.activeImage.classList.remove('is-dragging');
        this.activeImage = null;
      }

      handleKeyDown(e) {
        const image = e.currentTarget;
        const step = e.shiftKey ? 5 : 1;
        let deltaX = 0;
        let deltaY = 0;

        switch (e.key) {
          case 'ArrowLeft':
            deltaX = -step;
            break;
          case 'ArrowRight':
            deltaX = step;
            break;
          case 'ArrowUp':
            deltaY = -step;
            break;
          case 'ArrowDown':
            deltaY = step;
            break;
          case 'Enter':
          case ' ':
          case 'Spacebar':
            e.preventDefault();
            this.bringToFront(image);
            return;
          case 'Home':
            e.preventDefault();
            this.resetImage(image);
            return;
          default:
            return;
        }

        e.preventDefault();
        this.bringToFront(image);
        this.moveImageBy(image, deltaX, deltaY);
      }

      bringToFront(image) {
        this.maxZIndex += 1;
        image.style.zIndex = this.maxZIndex;
      }

      moveImageBy(image, deltaX, deltaY) {
        const boardRect = this.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const settings = this.getImageSettings(image);

        let currentX = parseFloat(image.style.left);
        let currentY = parseFloat(image.style.top);
        if (isNaN(currentX)) currentX = settings.x;
        if (isNaN(currentY)) currentY = settings.y;

        const minX = (imageRect.width / 2 / boardRect.width) * 100;
        const minY = (imageRect.height / 2 / boardRect.height) * 100;
        const newX = Math.max(minX, Math.min(100 - minX, currentX + deltaX));
        const newY = Math.max(minY, Math.min(100 - minY, currentY + deltaY));

        image.style.left = newX + '%';
        image.style.top = newY + '%';
        image.style.transform = 'translate(-50%, -50%) rotate(' + settings.rotation + 'deg)';
      }

      resetImage(image) {
        const settings = this.getImageSettings(image);
        const boardRect = this.getBoundingClientRect();

        image.style.zIndex = parseInt(image.dataset.layer, 10) || 0;
        image.style.width = (boardRect.width * settings.width) / 100 + 'px';
        image.style.height = 'auto';
        image.style.left = settings.x + '%';
        image.style.top = settings.y + '%';
        image.style.transform = 'translate(-50%, -50%) rotate(' + settings.rotation + 'deg)';
      }

      handleResize() {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 749;
        if (wasMobile !== this.isMobile) this.positionImages();
      }
    }

    customElements.define('interactive-image-board', InteractiveImageBoard);
  }

  } catch(e) { console.error(e); }
})();
})();
